import * as React from 'react'

import { useRouteTransition } from '@/hooks/use-route-transition'

interface LoadingSpinnerProps {
  color?: string
}

export default function LoadingSpinner({ color = '#f04438' }: LoadingSpinnerProps) {
  const [loading, setLoading] = React.useState(false)

  useRouteTransition({ onLoadingChange: setLoading })

  if (!loading) return null

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white/70 z-50">
      <div className="spinner-container">
        <div className="spinner"></div>
      </div>
      <style jsx>{`
        .spinner-container {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .spinner {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          border: 5px solid ${color}33;
          border-top-color: ${color};
          animation: spin 1s infinite linear;
        }
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  )
}
